import { reactNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/switch-v2.0.0'

const switchNode = reactNode(
	'Switch',
	{
		'v2.0.0': v200,
	},
	{ allowChildren: true, docs: '' }
)

import sgv200 from '@nodes/switch-group-v2.0.0'

const switchGroup = reactNode(
	'SwitchGroup',
	{
		'v2.0.0': sgv200,
	},
	{ allowChildren: true, docs: '' }
)

export { switchNode, switchGroup }